function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icons",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icons-/-Base",
  transform: "translate(-21.000000, -360.000000)",
  fill: "#318C05",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon-+-Label-Copy-21",
  transform: "translate(16.000000, 353.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon-/-chevronLeft",
  transform: "translate(5.500000, 7.500000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.2928932,0.292893219 C13.6834175,-0.0976310729 14.3165825,-0.0976310729 14.7071068,0.292893219 C15.0976311,0.683417511 15.0976311,1.31658249 14.7071068,1.70710678 L6.20710678,10.2071068 C5.81658249,10.5976311 5.18341751,10.5976311 4.79289322,10.2071068 L0.292893219,5.70710678 C-0.0976310729,5.31658249 -0.0976310729,4.68341751 0.292893219,4.29289322 C0.683417511,3.90236893 1.31658249,3.90236893 1.70710678,4.29289322 L5.5,8.085 L13.2928932,0.292893219 Z",
  id: "Path"
})))));

function SvgDaxCheckIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "11px",
    viewBox: "0 0 16 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / Check") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaxCheckIcon);
export default __webpack_public_path__ + "static/media/dax-checkIcon.01323d4f.svg";
export { ForwardRef as ReactComponent };